/**
 * @param { string } phone
 * @returns { string }
 */
export default function phoneFormat(phone) {
  return `${phone.slice(0, 2)} ${phone.slice(2, 6)} ${phone.slice(6)}`;
}
